import { useState } from "react";

export function useButtonPublishVacancy() {
  const [dialogVisible, setDialogVisible] = useState(false);

  const handleShowDialog = () => {
    setDialogVisible(true);
  };

  const handleHideDialog = () => {
    setDialogVisible(false);
  };

  return { dialogVisible, handleShowDialog, handleHideDialog };
}
